import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import ContactPcsIcon from 'dibs-vg/dist/react/circle-contact-info';
import PdpSharedBlurb from './PdpSharedBlurb/PdpSharedBlurb';
import { email } from '../pdpMessages';
import { pcsTitle, pcsText } from '../messages/pdpBlurbMessages';

// styles
import styles from './PdpSharedBlurbs.scss';

// helpers
import get from 'lodash.get';

// todo ho: replace icon (see https://1stdibs.atlassian.net/browse/FINDING-11748)
export function PdpSharedBlurbPcs({ user, vipUserRelationship }) {
    const vipSalesRep = get(vipUserRelationship, 'userDataB[0]');

    if (!user || user.isVerifiedTrade || !vipSalesRep) {
        return null;
    }

    return (
        <PdpSharedBlurb Icon={ContactPcsIcon}>
            <span className={styles.title}>{pcsTitle}: </span>
            {pcsText(vipSalesRep.firstName)}
            <div>
                <span>{vipSalesRep.phoneNumber}</span>
                <span className={styles.pcsDivider} />
                <span>
                    <a href={`mailto:${vipSalesRep.email}`}>{email}</a>
                </span>
            </div>
        </PdpSharedBlurb>
    );
}

PdpSharedBlurbPcs.propTypes = {
    user: PropTypes.object,
    vipUserRelationship: PropTypes.object,
};

export default createFragmentContainer(PdpSharedBlurbPcs, {
    user: graphql`
        fragment PdpSharedBlurbPcs_user on User {
            isVerifiedTrade
        }
    `,
    vipUserRelationship: graphql`
        fragment PdpSharedBlurbPcs_vipUserRelationship on UserRelationship {
            userDataB {
                ... on VipRepData {
                    email
                    firstName
                    phoneNumber(formatType: INTERNATIONAL)
                }
            }
        }
    `,
});
